<template>
  <div class="not__available">{{ getText }}</div>
</template>
<script>
export default {
  name: "BattlepassClosed",
  data() {
    return {
      text_block: {
        en: "Offer is not available",
        de: "Angebot ist nicht verfügbar",
        fr: "L'offre n'est pas disponible",
        pl: "Oferta nie jest dostępna",
        es: "La oferta no está disponible",
        cn: "优惠不可用",
        ru: "Акция недоступна",
      },
      domain_zone: window.location.host.split(".").reverse()[0],
      default_language: {
        ru: "ru",
        com: "en",
      },
      cur_lang: null,
    };
  },
  computed: {
    getText() {
      return this.text_block[this.cur_lang];
    },
  },
  mounted() {
    this.cur_lang = this.getCookie("cur_language") || this.default_language[this.domain_zone];
    document.title = "Warface - " + this.text_block[this.cur_lang];
  },
  methods: {
    getCookie(name) {
      let matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace("/([.$?*|{}()[]\\/+^])/g", "\\$1") + "=([^;]*)")
      );

      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  background: transparent;
  box-sizing: border-box;
}
.not__available {
  background: url("//wf.cdn.gmru.net/minigames_static/public/not_available/wf/images/background.png")
    no-repeat 50% 0;
  background-color: #000;
  width: 100vw;
  min-height: 100vh;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  font-family: Arial;
  font-size: 45px;
  line-height: 50px;
  padding-top: 200px;
}
</style>
